module.exports = __webpack_public_path__ + "img/food_1.94b01b51.svg";